import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Immutable, { Map, List } from 'immutable'; // eslint-disable-line

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import Input from '../../components/form/InputField';
import { validateAndDispatch } from '../../helpers/form';
import NavBarLoggedOut from '../../components/NavBarLoggedOut';
import { UserActions } from '../../actions/user';

if (__CLIENT__) {
  require('../../styles/Dashboard.css');
}

const resetPasswordFormSelector = state => {
  const selector = formValueSelector('resetPassword');
  return selector(state, 'newPassword', 'newPassword2');
};

const ResetPasswordSelector = immutableCreatorSelector(
  [resetPasswordFormSelector],
  resetPasswordForm => ({ fields: resetPasswordForm }),
);

@connect(ResetPasswordSelector)
@reduxForm({
  form: 'resetPassword',
})
class ResetPassword extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    hash: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = (values, dispatch) => {
    const { reset, hash } = this.props;

    const validation = {
      newPassword: [
        { rule: 'required', label: 'new password' },
        { rule: 'minLength:8', label: 'new password' },
      ],
      newPassword2: [
        { rule: 'required', label: 'new password again' },
        {
          rule: 'matchesField:newPassword',
          message: 'Field does not match the new password',
        },
      ],
    };

    return validateAndDispatch(
      dispatch,
      UserActions.resetPassword(hash, values),
      validation,
      values,
    ).then(() => {
      reset();
      dispatch(push('/login'));
    });
  };

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div className="main-container">
        <NavBarLoggedOut />
        <div className="row">
          <div className="col-md-12">
            <h2>Reset Password</h2>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="row">
                <div className="col-md-12">
                  <fieldset className="form-group">
                    <label htmlFor="newPassword">New Password</label>
                    <Field
                      name="newPassword"
                      component={Input}
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                    />
                    {/* <FieldError field={newPassword} /> */}
                  </fieldset>
                  <fieldset className="form-group">
                    <label htmlFor="newPassword2">New Password Again</label>
                    <Field
                      name="newPassword2"
                      component={Input}
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                    />
                    {/* <FieldError field={newPassword2} /> */}
                  </fieldset>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={submitting}
                  >
                    {submitting && (
                      <i className="fa fa-cog fa-spinner fa-spin" />
                    )}{' '}
                    Change Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default class ResetPasswordContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
  };

  render() {
    const { dispatch, params: { hash } } = this.props;
    return <ResetPassword hash={hash} dispatch={dispatch} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/public/ResetPassword.js